<app-view-title [isPrimaryColor]="true"></app-view-title>
<div #gmap id="map"></div>
@if(showPlaceSearch)
{
  <app-place-search (placeSelected)="search($event)"></app-place-search>
}

<div id="onlyBr" *ngIf="false">
  <mat-checkbox [ngModel]="hideExternalLocations" (change)="toggleHideExternalLocations($event)">Show only Brenderup Rental locations</mat-checkbox>
</div>

